import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable, throwError, concat } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AppSettings } from '../../utils/app-settings';
import {
  IGetOcaShippingByIdResponse,
  IGetOcaShippingResponse,
} from '../../interfaces/deliveries.interface';
import { UploadResponse } from '../file-upload/file-upload.service';

@Injectable({
  providedIn: 'root',
})

export class OcaDeliveriesService {
  constructor(private http: HttpClient, private appSettings: AppSettings) {}

  getOcaDeliveries(
    fechaDesde?: string,
    page?: number, 
    pageSize?: number, 
    estado?: string,
    q?: string,
    devoluciones?: boolean,
    estadoInterno?: string,
  ): Observable<IGetOcaShippingResponse> {
        console.log('llego al service')
        let url = this.appSettings.ocaDeliveries.urls.getOcaDeliveries;
        const params: string[] = [];
        
        // Add date parameters if provided
        if (fechaDesde) {
            params.push(`fechaDesde=${fechaDesde}`);
        }
        
        // Add pagination parameters
        if (page !== undefined) {
            params.push(`page=${page}`);
        }
        
        if (pageSize !== undefined) {
            params.push(`pageSize=${pageSize}`);
        }
        
        if (estado) {
            params.push(`estado=${estado}`);
        }
        
        if (q) {
            params.push(`q=${encodeURIComponent(q)}`);
        }

        if (devoluciones !== undefined) {
            params.push(`devoluciones=${devoluciones}`);
        }

        if (estadoInterno) {
            params.push(`estadoInterno=${estadoInterno}`);
        }

        // Append parameters to URL
        if (params.length > 0) {
            url += '?' + params.join('&');
        }
        
        console.log('URL:', url);
        
        return this.http.get<IGetOcaShippingResponse>(url).pipe(
            tap({
                next: (response: IGetOcaShippingResponse) => {
                    console.log('HTTP Response:', response);
                },
                error: (error: any) => {
                    console.error('HTTP Error:', error);
                }
            })
        );
  }

  getOcaDeliveryByTrackingNumber(trackingNumber: string): Observable<IGetOcaShippingByIdResponse> {
    return this.http.get<IGetOcaShippingByIdResponse>(
      this.appSettings.ocaDeliveries.urls.getOcaDeliveryById + '?trackingNumber=' + trackingNumber
    );
  }

  getOcaReturnByTrackingNumber(trackingNumber: string): Observable<IGetOcaShippingByIdResponse> {
    return this.http.get<IGetOcaShippingByIdResponse>(
      this.appSettings.ocaDeliveries.urls.getOcaDeliveryById + '?trackingNumber=' + trackingNumber + '&devoluciones=true'
    );
  }

  uploadFile(
    shippingId: string,
    receiptId: number,
    file: File
  ): Observable<HttpEvent<UploadResponse>> {
    const url = this.appSettings.ocaDeliveries.urls.uploadFile(shippingId as any, receiptId);
    const formData = new FormData();
    formData.append('files', file, file.name);

    const request = new HttpRequest('POST', url, formData, {
      reportProgress: true,
      responseType: 'json',
    });

    return this.http.request<UploadResponse>(request).pipe(
      catchError((error) => {
        const errorMessage = error.error?.message || 'Error al subir el archivo';
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  uploadFiles(
    shippingId: string,
    receiptId: number,
    files: File[]
  ): Observable<HttpEvent<UploadResponse>> {
    const url = this.appSettings.ocaDeliveries.urls.uploadFile(shippingId as any, receiptId);

    const requests$ = files.map(file => {
      const formData = new FormData();
      formData.append('files', file, file.name);

      const request = new HttpRequest('POST', url, formData, {
        reportProgress: true,
        responseType: 'json',
      });

      return this.http.request<UploadResponse>(request);
    });

    return concat(...requests$).pipe(
      catchError((error) => {
        const errorMessage = error.error?.message || 'Error al subir los archivos';
        return throwError(() => new Error(errorMessage));
      })
    );
  }
}
